import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App.jsx';
import Navbar from './components/navbar.jsx'
import Footer from "./components/footer.jsx"
import { LogoMini,Logo } from './components/logo.jsx';
import { BrowserRouter as BR } from "react-router-dom";
import {Whatsapp} from "./components/whatsapp";
document.documentElement.style.setProperty("color-scheme", "dark");


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BR>
      <Navbar />
      <LogoMini />
      <Logo/>
      <App />
      <Whatsapp />
      <Footer />
    </BR>
  </React.StrictMode>
);

